import Vue from 'vue'
import Antd from 'ant-design-vue';
import App from './AppBingsport'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'ant-design-vue/dist/antd.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import './assets/scss/main-bingsport.scss';
import jQuery from "jquery";

Vue.config.productionTip = false

Vue.use(Antd);
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.$ = jQuery;
import {VueRecaptcha} from "vue-recaptcha";
Vue.component('vue-recaptcha', VueRecaptcha);

new Vue({
  render: h => h(App),
}).$mount('#app')
